import tw from 'twin.macro';

export const BackDrop = tw.div`
    fixed inset-0 bg-[#4B4B4B] opacity-40
`;
